module.exports = __webpack_public_path__ + "img/marker_odp_demenagement-0.7c1822cb.png";